import { createStore, applyMiddleware, combineReducers } from 'redux';
import authentication from '../_reducers/login.reducer';
import containerReducer from '../_reducers/container.reducer';
import containerTripData from '../_reducers/containerTripData.reducer';
import loaderReducer from '../_reducers/loader.reducer';

import userProfileInfoReducer from '../_reducers/userProfileInfo.reducer';
// manage profile
import addProfileReducer from '../_reducers/addProfile.reducer';
import manageProfileReducer from '../_reducers/manageProfile.reducers';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { CookieStorage } from 'redux-persist-cookie-storage';
import Cookies from 'cookies-js';
// const loggerMiddleware = createLogger();
const rootReducer = combineReducers({authentication,containerReducer,containerTripData
  ,addProfileReducer,manageProfileReducer,userProfileInfoReducer, loaderReducer})
  Cookies.defaults = {
    path: '/',
    secure: true,
    httpOnly: true,
    expires : Cookies.get('expires')
};
const persistConfig = {
key: 'root',
storage: storage,// new CookieStorage(Cookies),
blacklist: ['authentication','loaderReducer', 'containerReducer','containerTripData'] 
};
const pReducer = persistReducer(persistConfig, rootReducer,  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
export const store = createStore(pReducer, undefined)
export const persistor = persistStore(store, {})
export default store;
// const persistConfig = {
//     key: 'root',
//     storage: storage,
//     stateReconciler: autoMergeLevel2, // see "Merge Process" section for details.
// };
//    const pReducer = persistReducer(persistConfig, rootReducer);
//    export const store = createStore(pReducer);
//    export const persistor = persistStore(store);
//  export default store;